/**
 * Types de sentiers OSM (calques Martin trails-*).
 */
import i18n from '../../../i18n'
import {
  HIKING_TRAIL_LAYER_IDS,
  layerIdsForTrailToggle,
  MARTIN_TRAIL_LAYER_SPECS,
} from './martinTrailLayers'

export const MAP_TRAIL_TYPE_IDS = [
  'hiking',
  'cycling',
  'mtb',
  'nordic',
  'snowshoe',
  'alpine',
  'atv',
  'snowmobile',
] as const

export type MapTrailTypeId = (typeof MAP_TRAIL_TYPE_IDS)[number]

export type MapTrailTypeSelection = Record<MapTrailTypeId, boolean>

export const MAP_TRAIL_TYPE_LABELS: Record<MapTrailTypeId, string> = {
  get hiking() { return i18n.t('map:mapTrailTypes.randonnee') },
  get cycling() { return i18n.t('map:mapTrailTypes.velo') },
  get mtb() { return i18n.t('map:mapTrailTypes.velo_montagne') },
  get nordic() { return i18n.t('map:mapTrailTypes.ski_fond') },
  get snowshoe() { return i18n.t('map:mapTrailTypes.raquette') },
  get alpine() { return i18n.t('map:mapTrailTypes.ski_alpin') },
  get atv() { return i18n.t('map:mapTrailTypes.quad_vtt') },
  get snowmobile() { return i18n.t('map:mapTrailTypes.motoneige') },
}

export const DEFAULT_TRAIL_TYPE_SELECTION: MapTrailTypeSelection = {
  hiking: false,
  cycling: false,
  mtb: false,
  nordic: false,
  snowshoe: false,
  alpine: false,
  atv: false,
  snowmobile: false,
}

const STORAGE_KEY = 'mapState_trail_types'

export function trailLayerId(typeKey: MapTrailTypeId): string {
  return `trails-${typeKey}`
}

export { HIKING_TRAIL_LAYER_IDS, layerIdsForTrailToggle, MARTIN_TRAIL_LAYER_SPECS }

/** Calques AQréseau+ (FCMQ motoneige, FQCQ quad). */
export const AQP_LAYER_MAP: Partial<Record<MapTrailTypeId, string>> = {
  snowmobile: 'trails-snowmobile-aqp',
  atv: 'trails-atv-aqp',
}

/** Les sentiers OSM peuvent être injectés sur tout fond (pas seulement pmtiles-flat). */
export function styleHasMartinTrails(_styleId: string | null | undefined): boolean {
  return true
}

export function hasAnyTrailTypeSelected(
  selection: MapTrailTypeSelection | null | undefined,
): boolean {
  if (!selection) return false
  return MAP_TRAIL_TYPE_IDS.some((id) => selection[id])
}

export function normalizeTrailTypeSelection(
  raw: Partial<MapTrailTypeSelection> | null | undefined,
): MapTrailTypeSelection {
  const out = { ...DEFAULT_TRAIL_TYPE_SELECTION }
  if (!raw) return out
  for (const id of MAP_TRAIL_TYPE_IDS) {
    if (typeof raw[id] === 'boolean') out[id] = raw[id]
  }
  return out
}

export function loadStoredTrailTypes(): MapTrailTypeSelection {
  if (typeof window === 'undefined') return { ...DEFAULT_TRAIL_TYPE_SELECTION }
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return { ...DEFAULT_TRAIL_TYPE_SELECTION }
    return normalizeTrailTypeSelection(JSON.parse(raw) as Partial<MapTrailTypeSelection>)
  } catch {
    return { ...DEFAULT_TRAIL_TYPE_SELECTION }
  }
}

export function saveTrailTypes(selection: MapTrailTypeSelection): void {
  if (typeof window === 'undefined') return
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(selection))
  } catch {
    // ignore
  }
}

export function toggleTrailType(
  selection: MapTrailTypeSelection,
  id: MapTrailTypeId,
): MapTrailTypeSelection {
  const next = { ...selection, [id]: !selection[id] }
  saveTrailTypes(next)
  return next
}
